import React from 'react';
import { Box, TextField, InputLabel, FormHelperText } from '@mui/material';
import { Controller } from 'react-hook-form';
import { pad } from 'lodash';

interface TextInputFieldProps {
  name: string;
  label: string;
  control: any;
  placeholder?: string;
  isTextArea?: boolean;
  rules?: any;
  disabled?: boolean;
  type?: string;
}

const labelStylestextfield = {
  fontSize: "18px",
  fontWeight: 500,
  color: "#333333",
  paddingLeft: "14px",
};

export const TextInputField = ({ 
  name, 
  label, 
  control, 
  placeholder, 
  isTextArea = false, 
  rules,
  disabled = false,
  type = "text"
}: TextInputFieldProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
    <InputLabel shrink sx={labelStylestextfield}>
      {label}
    </InputLabel>
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <>
          <TextField
            {...field}
            fullWidth
            type={type}
            placeholder={placeholder}
            error={!!error}
            multiline={isTextArea}
            minRows={isTextArea ? 3 : 1}
            disabled={disabled}
            sx={{
              boxShadow: "0px 0px 11px 2px #4B44D41A inset",
              borderRadius: isTextArea ? "10px" : "95px",
              color: "#777777",
              "& .MuiOutlinedInput-root": {
                borderRadius: isTextArea ? "10px" : "95px",
                "& fieldset": {
                  borderColor: "#E0E0E0",
                },
                "&:hover fieldset": {
                  borderColor: "#756DE9",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#756DE9",
                },
              },
              "& .MuiInputBase-input": {
                padding: isTextArea ? "12px 14px" : "12px 20px",
                color: "#333333",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#777777",
                opacity: 1,
              },
            }}
          />
          <FormHelperText sx={{ color: "#d32f2f", ml: "14px", mb: "6px", mt: 0 }}>
            {error ? error.message : " "}
          </FormHelperText>
        </>
      )}
    />
  </Box>
);